const form = document.querySelector('.offer-form')
const loader = form.querySelector('.loader')
const submitButton = form.querySelector('.submit-button')
const responseMessage = form.querySelector('.offer-response-message')
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
const phoneNumberRegex = /^[0-9+()\s-]+$/
const pageTitle = document.querySelector('h1').textContent
// Validation Function
const validateForm = () => {
	let isCorrect = true
	const requiredFields = document.querySelectorAll('.offer-form.form-to-validation .required')

	requiredFields.forEach(input => {
		const errInfo = input.parentElement.querySelector('p')
		errInfo.style.color = '#fff'
		errInfo.classList.add('text-center')
		errInfo.innerHTML = ''

		if (!input.value.trim() && input.type !== 'checkbox') {
			errInfo.innerHTML = 'Uzupełnij wymagane pole'
			isCorrect = false
		} else if (input.type === 'email' && !emailRegex.test(input.value)) {
			errInfo.innerHTML = 'Podaj poprawny adres e-mail'
			isCorrect = false
		} else if (input.type === 'tel' && !phoneNumberRegex.test(input.value)) {
			errInfo.innerHTML = 'Podaj poprawny numer telefonu'
			isCorrect = false
		} else if (input.type === 'file') {
			if (input.files.length === 0) {
				errInfo.innerHTML = 'Dodaj załącznik z CV'
				isCorrect = false
			} else if (input.files[0].size > 5242880) {
				errInfo.innerHTML = 'Rozmiar pliku nie powinien przekraczać 5 MB'
				isCorrect = false
			}
		} else if (input.type === 'checkbox' && !input.checked) {
			errInfo.innerHTML = 'Zaznacz wymagane pole'
			isCorrect = false
		}
	})

	return isCorrect
}
// SEND FORM
const sendFormData = async formData => {
	const baseURL = `${window.location.protocol}//${window.location.hostname}${
		window.location.port ? ':' + window.location.port : ''
	}`
	const url = `${baseURL}/wp-content/themes/MinisterstwoReklamy/mail-lib/section-offer-form/ajax/send-email.php`

	const data = {
		email: 'sprzedaz@ministerstworeklamy.pl',
		subject: 'Formularz z usługi',
		content: `Imię: ${formData.get('name')}<br/>Usługa:${pageTitle}<br/>Email: ${formData.get(
			'email'
		)}<br/>Telefon: ${formData.get('number')}<br/>Wiadomość: ${formData.get('content')}`
	}

	try {
		const response = await fetch(url, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(data)
		})

		if (!response.ok) throw new Error('Network response was not ok')

		const rawData = await response.text()

		try {
			const parsedData = JSON.parse(rawData)

			form.reset()
			responseMessage.classList.remove('!hidden')
			setTimeout(() => {
				responseMessage.classList.add('!hidden')
			}, 5000)
		} catch (error) {
			console.error('JSON parsing error:', error)
		}
	} catch (error) {
		console.error('Fetch error:', error)
	} finally {
		loader.classList.add('!hidden')

		submitButton.disabled = false
	}
}

// **Form Submit Event
form.addEventListener('submit', function (e) {
	e.preventDefault()

	if (validateForm()) {
		loader.classList.remove('!hidden')
		submitButton.disabled = true
		sendFormData(new FormData(this))
	} else {
		loader.classList.add('!hidden')
	}
})
